import HttpClient from "src/services/httpclient"

export type LanguageBody = {
    name : string
    code : string
    direction : string
    flag? : string | null
}

class Language {
    public static createLanguage = (AdminInfos:LanguageBody) => {
        return HttpClient.postWithLogin('/language/store',AdminInfos)
    }
    public static updateLanguage = (id:string,AdminInfos:LanguageBody) => {
        return HttpClient.postWithLogin(`/language/update/${id}`,AdminInfos)
    }
    public static getLanguages = () => {
        return HttpClient.getWithLogin('/language/all')
    }
    public static getLanguage = (id : string) => {
        return HttpClient.getWithLogin(`/language/show/${id}`)
    }
    public static deleteLanguage = (id:string) => {
        return HttpClient.deleteWithLogin(`/language/delete/${id}`)
    }

    public static getOpenLanguages = () => {
        return HttpClient.get('/patient/language/all')
    } 

    public static translateLanguageQuestions = (languageId:number) => {
        return HttpClient.postWithLogin(`/translation/make-one/${languageId}`,null)
    } 
}

export default Language